import axios from 'axios';
// import { IS_PRODUCTION } from '@/main.js';
import { get } from 'lodash';

const prod = true

export const axiosConfig = (token, contentType) => ({
  baseURL: prod ? "https://api.lancul.com/" : "/api",
  headers: {
    'Content-Type': contentType || 'application/json',
    ...(token ? {Authorization: token} : {})
  }
});

export const axiosGetHandler = async (url, config) => {
  const res = await axios.get(url, config);
  if (res.status !== 200) {
    // console.log('API response status is ', res.status);
    throw new Error(res);
  }
  if (get(res, 'data.errorMessage')) {
    // console.log('API response error message is ', get(res, 'data.errorMessage'));
    throw new Error(get(res, 'data.errorMessage') || res);
  }
  if (
    get(res, 'data.statusCode') === 400 || //To be deprecated and replace by "statusCode: 1" for errors
    get(res, 'data.statusCode') === 1
  ) {
    // console.log('API response body error message ', get(res, 'data.body'));
    const errorMsg = get(res, 'data.statusMessage') || get(res, 'data.body') || res;
    throw new Error(errorMsg);
  }
  return res;
};

export const axiosHandler = async (url, postData, config) => {
  const res = await axios.post(url, postData, config);
  // if (res.status !== 200) {
  //   // console.log('API response status is ', res.status);
  //   throw new Error(res);
  // }
  // if (get(res, 'data.errorMessage')) {
  //   // console.log('API response error message is ', get(res, 'data.errorMessage'));
  //   throw new Error(get(res, 'data.errorMessage') || res);
  // }
  // if (
  //   get(res, 'data.statusCode') === 400 || //To be deprecated and replace by "statusCode: 1" for errors
  //   get(res, 'data.statusCode') === 1
  // ) {
  //   // console.log('API response body error message ', get(res, 'data.body'));
  //   const errorMsg = get(res, 'data.statusMessage') || get(res, 'data.body') || res;
  //   throw new Error(errorMsg);
  // }
  return res;
};

export const createUUID = () => {
  let dt = new Date().getTime()
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (dt + Math.random()*16)%16 | 0
      dt = Math.floor(dt/16)
      return (c ==='x' ? r : (r&0x3|0x8)).toString(16)
  })
  return uuid
};